import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import SettingRepository from "@/modules/settings/services/SettingRepository";
import GameSaver from "@/modules/main-menu/services/GameSaver";
import {GameSlot} from "@/modules/main-menu/entity";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {BeforeDayEvaluationEvent} from "@/modules/season/events/BeforeDayEvaluationEvent";
import {persistDataSource} from "@/modules/database/services/db";
import {db} from "@/modules/base/services/db";
import {DialogService} from "@/modules/vue/services/DialogService";

@injectable()
export class AutoSaveEventSubscriber implements EventSubscriber {
  constructor(
    @inject(SettingRepository) private settingRepository: SettingRepository,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
    @inject(GameSaver) private gameSaver: GameSaver,
    @inject(DialogService) private dialogService: DialogService,
  ) {
  }

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeDayEvaluationEvent, callback: this.onBeforeDayEvaluationEvent},
    ];
  }

  async onBeforeDayEvaluationEvent(event: BeforeDayEvaluationEvent): Promise<void> {
    if (!await this.settingRepository.get('auto_save')) {
      console.debug('Auto save is disabled.');
      return;
    }

    if (!event.season.currentDate.startOf('month').isSame(event.season.currentDate, 'day')) {
      return;
    }

    const gameId = await this.settingRepository.get('game_id') as string;

    let gameSlot = await GameSlot.findOne({
      where: {
        gameId: await this.settingRepository.get('game_id') as string,
      }
    });

    if (!gameSlot) {
      gameSlot = new GameSlot();
      gameSlot.gameId = gameId;
    }

    await this.dialogService.doLoading(async () => {
      await this.gameSaver.save({
        gameSlot,
        autoSave: true,
      });
    });

    await persistDataSource(db);
  }
}